import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { PricingPlansParams } from 'src/queries/organizations/pricingPlans/pricingPlans.models'
import {
  getPricingPlans,
  getPricingPlansLookup,
  getSaasEligibility,
} from 'src/queries/organizations/pricingPlans/pricingPlans.network'

export const normalizePricingPlansParams = (
  params?: PricingPlansParams,
): PricingPlansParams => {
  const normalizedParams: PricingPlansParams = {}
  if (params?.issuerId) normalizedParams.issuerId = params.issuerId
  if (params?.skipRedirect) normalizedParams.skipRedirect = true
  return normalizedParams
}

export const pricingPlansQueryKeys = {
  all: () => ['pricingplans'] as const,
  list: (organizationId: string | undefined, params?: PricingPlansParams) =>
    [
      ...pricingPlansQueryKeys.all(),
      'list',
      organizationId,
      params ?? {},
    ] as const,
  lookup: (bin: string) =>
    [...pricingPlansQueryKeys.all(), 'lookup', bin] as const,
  saasEligibility: (issuerId: string | undefined) =>
    [...pricingPlansQueryKeys.all(), 'saasEligibility', issuerId] as const,
}

const getSaasEligibilityForIssuer = (issuerId: string | undefined) => {
  if (!issuerId) {
    throw new Error('SaaS eligibility issuerId is required')
  }

  return getSaasEligibility(issuerId)
}

export const pricingPlanQueries = {
  list: (organizationId: string | undefined, params?: PricingPlansParams) => {
    const normalizedParams = normalizePricingPlansParams(params)

    return queryOptions({
      queryKey: pricingPlansQueryKeys.list(organizationId, normalizedParams),
      queryFn: () => getPricingPlans(organizationId!, normalizedParams),
      enabled: Boolean(organizationId),
    })
  },
  lookup: (bin: string) =>
    queryOptions({
      queryKey: pricingPlansQueryKeys.lookup(bin),
      queryFn: () => getPricingPlansLookup(bin),
      enabled: !!bin,
      placeholderData: keepPreviousData,
      retry: false,
    }),
  saasEligibility: (issuerId: string | undefined) =>
    queryOptions({
      queryKey: pricingPlansQueryKeys.saasEligibility(issuerId),
      queryFn: () => getSaasEligibilityForIssuer(issuerId),
      enabled: Boolean(issuerId),
      retry: false,
    }),
}
